import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Chatbot from './components/Chatbot';
import Signup from './components/Signup';
import SupportBotLanding from './components/Hub/SupportBotLanding';
import AMPLandingPage from './components/Hub/AMP\'s/AMPLandingPage';
import AMPChatPage from './components/Hub/AMP\'s/AMPChatPage';
import MACLandingPage from './components/Hub/MAC/MACLandingPage';
import HubBilling from './components/Hub/Billing/HubBilling';
import HubSettings from './components/Hub/Settings/HubSettings';
import ValidationPage from './components/ValidationPage';

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Chatbot />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/supportbot/:guid" element={<SupportBotLanding />} />
        <Route path="/amps" element={<AMPLandingPage />} />
        <Route path="/amp/:ampId/:guid" element={<AMPChatPage />} />
        <Route path="/mac" element={<MACLandingPage />} />
        <Route path="/billing" element={<HubBilling />} />
        <Route path="/settings" element={<HubSettings />} />
        <Route path="/hubvalidation" element={<ValidationPage />} />
      </Routes>
    </Router>
  );
}
